export const getDataTableData = (t) => {
    return {
      columns: [
        {
          id: "e1ebde41-c7e5-41a6-b969-7cdd916cb643",
          field: "name",
          align: "left",
          headerName: t("contractors.list.column.name"),
          label: "contractors.list.column.name",
          flex: 1,
          editable: true,
        },
        {
          id: "e1ebde41-c7e5-41a6-b969-7cdd916cb645",
          field: "email",
          align: "left",
          headerName: t("contractors.list.column.email"),
          label: "contractors.list.column.email",
          flex: 1,
          editable: true,
        },
      ],
    };
  };
  